import { render, staticRenderFns } from "./EbImg.vue?vue&type=template&id=720e8b50"
import script from "./EbImg.vue?vue&type=script&lang=js"
export * from "./EbImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports